<template>
    <v-alert
      :value="display"
      type="error"
      dismissible
    >
      {{content}}
    </v-alert>
</template>

<script>
    export default {
        components: {
            
        },
        props: ["content", "display"],
        methods:{
        	
        }
    }
</script>
